<template>
  <div class="replace-checkbox">
    <input type="checkbox"
           v-model="inputModel"
           :name="name"
           :id="id"
           :required="required"
           :aria-describedby="ariaDescribedby"
           :aria-labelledby="ariaLabelledby"
           style="display: none !important;"
           :value="value"
           class="vue-replaced"
           :class="className" />

    <n-checkbox
        v-model:checked="inputModel"
        :disabled="disabled"
    >
      <slot />
    </n-checkbox>
  </div>
</template>

<script lang="ts" setup>
import {ref} from 'vue'
import { NCheckbox } from 'naive-ui'

interface Props {
  checked?: boolean
  value?: string | number | boolean
  name?: string
  id?: string
  disabled?: boolean
  required?: boolean
  ariaDescribedby?: string
  ariaLabelledby?: string
  className?: string | string[] | Record<string, boolean>
}

const props = defineProps<Props>()
const inputModel = ref(false)

defineOptions({
  name: 'InputCheckbox'
})
</script>

<style lang="scss">
.replace-checkbox {
  .n-checkbox {
    .n-checkbox-box {
      border-radius: 4px;
    }

    .n-checkbox-box__border {
      box-shadow: none;
      border: var(--n-border);
    }
  }
}
</style>
